import { TUTULIST_LOWERCASE, TUTULIST_USER_ID } from './enums';
import * as listingVisibility from './listingVisibility';

const { ENCORE_PUBLIC_DATA_KEY, filterPublicListings, isEncoreCollectionListing } =
  listingVisibility;

export const TUTULIST_ENCORE_PUBLIC_DATA_KEY = ENCORE_PUBLIC_DATA_KEY;
export const TUTULIST_ENCORE_QUERY_PARAM = `pub_${TUTULIST_ENCORE_PUBLIC_DATA_KEY}`;

const normalizeHandle = value =>
  (value || '')
    .toString()
    .trim()
    .toLowerCase();

export const isTutulistHandle = value => normalizeHandle(value) === TUTULIST_LOWERCASE;

const getSellerUsername = seller =>
  seller?.attributes?.profile?.publicData?.username || seller?.username || null;

const getSellerSlug = seller =>
  seller?.attributes?.profile?.publicData?.slug || seller?.slug || null;

export const isTutulistSeller = seller => {
  if (!seller) return false;

  const id = seller?.id?.uuid || seller?.id;
  if (id && id === TUTULIST_USER_ID) return true;

  const username = getSellerUsername(seller);
  const slug = getSellerSlug(seller);

  return isTutulistHandle(username) || isTutulistHandle(slug);
};

export const isTutulistEncoreListing = listing => isEncoreCollectionListing(listing);

export const filterOutTutulistListings = listings => filterPublicListings(listings);

export const filterOutTutulistSellers = sellers =>
  Array.isArray(sellers) ? sellers.filter(seller => seller && !isTutulistSeller(seller)) : [];

export const isTutulistEncoreQueryParam = queryParamName =>
  queryParamName === TUTULIST_ENCORE_QUERY_PARAM;

export const hasTutulistEncoreQueryParam = params =>
  !!params && Object.prototype.hasOwnProperty.call(params, TUTULIST_ENCORE_QUERY_PARAM);

export const stripTutulistEncoreQueryParam = params => {
  if (!params || !hasTutulistEncoreQueryParam(params)) {
    return params || {};
  }
  const { [TUTULIST_ENCORE_QUERY_PARAM]: _removed, ...rest } = params;
  return rest;
};

export const isTutulistEncoreFilterConfig = filterConfig => {
  if (!filterConfig) return false;
  const queryParamNames = Array.isArray(filterConfig.queryParamNames)
    ? filterConfig.queryParamNames
    : [filterConfig.queryParamNames];
  return (
    queryParamNames.includes(TUTULIST_ENCORE_QUERY_PARAM) || filterConfig?.id === 'encore'
  );
};

export const isTutulistEncoreQuickFilter = quickFilter =>
  typeof quickFilter?.search === 'string' &&
  quickFilter.search.includes(TUTULIST_ENCORE_QUERY_PARAM);

export const filterOutTutulistQuickFilters = quickFilters =>
  Array.isArray(quickFilters)
    ? quickFilters.filter(filter => !isTutulistEncoreQuickFilter(filter))
    : [];
